import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AnnouncementAddFormModel } from './announcement-add-form.model';

export class AnnouncementAddFormBuilder {
  static createFormGroup(): FormGroup<AnnouncementAddFormModel> {
    return new FormGroup<AnnouncementAddFormModel>({
      title: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      content: new FormControl(null, [Validators.required]),
      channel: new FormControl(null, [Validators.required]),
      requiresConfirmation: new FormControl(null),
      startDate: new FormControl(null),
      endDate: new FormControl(null),
      plannedEmailSendAt: new FormControl(null),
      recipientType: new FormControl(null, [Validators.required]),
      recipients: new FormControl(null),
      requestCode: new FormControl(null),
    });
  }
}
